import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { NotificationManager } from "react-notifications";
import { UpdateEmailBody } from "../../vlp/services/GeneralMaintenanceService";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const HTMLViewerEditor = ({
  isOpen,
  onClose,
  title,
  message,
  color,
  emailType,
}) => {
  const [editedHTML, setEditedHTML] = useState("");
  const [isChanged, setIsChanged] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setEditedHTML(message);
    setIsChanged(false);
  }, [message]);

  const handleInputChange = (value) => {
    setEditedHTML(value);
    setIsChanged(true);
  };

  const handleUpdateClick = async () => {
    try {
      setLoading(true);

      // HTML Template with HTML5 DOCTYPE
      const htmlTemplate = `
        <!DOCTYPE html>
        <html>
          <head>
            <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
            <style type="text/css">
              body { text-align:left; background-color: #F9F9F9; }
              h3, p { font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Arial, sans-serif; margin: 0 0 10px 0; }
              .subtext { font-size: 12px; margin-top: 10px; }
              .rating { unicode-bidi: bidi-override; direction: rtl; text-align: center; font-size: 36px; }
              .rating a { text-decoration: none; color: #DEDEDE; text-shadow:1px 1px 1px #666666; }
              a:hover { color: #FDD017 !important; }
              .rating > a { display: inline-block; position: relative; width: 1.1em; }
              .rating > a:hover, .rating > a:hover ~ a { color: #FDD017; }
              .rating > a:hover:before, .rating > a:hover ~ a:before { content: "\\2605"; position: absolute; left: 1; color: #FDD017; }
            </style>
          </head>
          <body>
            <div>
              ${editedHTML}
            </div>
          </body>
        </html>
      `;

      await UpdateEmailBody(emailType, htmlTemplate);
      NotificationManager.success("Email body updated successfully.");
      onClose();
    } catch (error) {
      NotificationManager.error("Error updating email body.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog fullScreen open={isOpen} onClose={onClose}>
      <AppBar position="relative">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2, flex: 1, color }}>
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper style={{ margin: "20px", padding: "20px" }}>
        {/* HTML Preview */}
        <Typography variant="body1">
          <div dangerouslySetInnerHTML={{ __html: editedHTML }} />
        </Typography>
      </Paper>

      {emailType && (
        <Paper style={{ margin: "20px", padding: "20px" }}>
          <ReactQuill
            theme="snow"
            value={editedHTML}
            onChange={handleInputChange}
            modules={{
              toolbar: [
                [{ font: [] }],
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ color: [] }, { background: [] }],
                [{ script: "sub" }, { script: "super" }],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{ align: [] }],
                ["link", "image"],
                ["clean"],
              ],
            }}
            formats={[
              "font",
              "header",
              "bold",
              "italic",
              "underline",
              "strike",
              "color",
              "background",
              "script",
              "list",
              "bullet",
              "indent",
              "align",
              "link",
              "image",
            ]}
            style={{ height: "300px", marginBottom: "40px" }}
          />
          <br />
          <Button
            autoFocus
            variant="contained"
            color="primary"
            onClick={handleUpdateClick}
            disabled={!isChanged || loading}
            style={{ float: "right" }}
          >
            Update
          </Button>
        </Paper>
      )}
    </Dialog>
  );
};

export default HTMLViewerEditor;
